module.exports = __webpack_public_path__ + "img/background.8a10b6a7.jpg";